var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuitModal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.08054 10.4877L3.98912 6.39631L5.53247 4.85297L9.62388 8.94438L13.591 4.97726L15.1654 6.55168L11.1983 10.5188L15.2897 14.6102L13.7464 16.1536L9.65495 12.0621L5.68784 16.0293L4.11342 14.4548L8.08054 10.4877Z",
    fill: "#646464"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuitModal);
export default __webpack_public_path__ + "static/media/quitModal.42a8211e9d412075fb5001a999613ef6.svg";
export { ForwardRef as ReactComponent };